import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const apiBase = createApi({
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_API_URL}/api/`,
		credentials: 'include'
	}),
	tagTypes: ['article'],
	endpoints: () => ({}),
})